export const api = import.meta.env.VITE_APP_API
export const token = import.meta.env.VITE_APP_TOKEN
export const DSN = import.meta.env.SENTRY_DSN
export const TargetUrl = import.meta.env.SENTRY_URL
export const encryptionKey = import.meta.env.VITE_APP_ENCRYPTION_KEY
export const MixPanel = import.meta.env.VITE_APP_MIXPANEL_TOKEN
export const instrumentationKey = import.meta.env.VITE_INSTRUMENTATION_KEY
